import '../../App.css';
import SolutionHero from '../../components/SolutionHero';
import PageHelmet from '../../components/PageHelmet';

function SnapVALUES() {
  return (
    <div className="app">
      <PageHelmet
        title="SnapRISK | SnapVALUES"
        description="Smarter property value insights and valuation support with SnapVALUES from SnapRISK."
        path="/solutions/snapvalues"
      />
      <SolutionHero
        pageId="snapvalues"
        imageSrc="/img/solutions/snapvalues.jpeg"
        imageAlt="SnapVALUES"
        title="SnapVALUES™"
        description="SnapVALUES™ is a property valuation tool that delivers fast, accurate replacement cost estimates – empowering better insurance decisions and reducing underinsurance risk. SnapVALUES™ uses mobile technology to replace spreadsheets and makes values collection infinitely easier, more accurate and defensible."
        solution="snapvalues"
      />

      <section className="px-4 pb-16 pt-4 sm:px-6 md:px-10 lg:px-16 lg:pb-20">
        <div className="mx-auto max-w-6xl space-y-10">
          <div className="relative overflow-hidden rounded-3xl border border-primary/20 bg-secondary p-8 shadow-sm md:p-10">
            <div className="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-primary/15" />
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">ABC's</p>
            <h2 className="mt-3 text-3xl font-semibold tracking-tight text-gray-900 md:text-4xl">The big A's of SnapVALUES</h2>
            <ul className="mt-8 space-y-4 text-lg leading-relaxed text-gray-700">
              <li className="flex items-start gap-3">
                <span className="mt-1 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-semibold text-white">1</span>
                <span>Automatically identifies discrepancies, significant changes and outliers. </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-1 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-semibold text-white">2</span>
                <span>Accommodates all currencies and exchanges either in real-time or fixed date. </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-1 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-semibold text-white">3</span>
                <span>Automated tracking and follow-up ensures local teams complete the required task. </span>
              </li>
            </ul>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <article className="group rounded-2xl border border-gray-200 bg-white p-7 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-lg">
              <p className="text-sm font-semibold uppercase tracking-[0.16em] text-primary">Feature 01</p>
              <h3 className="mt-2 text-xl font-semibold text-gray-900">Streamlined Data Management & Integration</h3>
              <p className="mt-3 text-base leading-relaxed text-gray-700">
              Eliminates time-consuming data collection methods while centralizing and memorializing values for real-time year-over-year 
              analysis; easily integrates with internal and external systems, with acquisitions and updates seamlessly managed by stakeholders 
              to ensure accurate SOV submissions 
              </p>
            </article>

            <article className="group rounded-2xl border border-gray-200 bg-white p-7 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-lg">
              <p className="text-sm font-semibold uppercase tracking-[0.16em] text-primary">Feature 02</p>
              <h3 className="mt-2 text-xl font-semibold text-gray-900">Why SnapVALUES is Important?</h3>
              <p className="mt-3 text-base leading-relaxed text-gray-700">
              Property valuation delivers market value data to support informed decision-making for transactions, financing, and regulatory requirements. 
              </p>
            </article>
          </div>

          <div className="relative overflow-hidden rounded-3xl bg-gray-900 p-8 md:p-10 text-center">
            <div className="rounded-full bg-primary/35 blur-2xl" />
            <p className="relative text-2xl font-medium leading-relaxed text-white text-center">
            With SnapVALUES™ you know your numbers – before it costs you. 
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}

export default SnapVALUES;
